export const MAX_IMAGE_SIZE = 1024 * 1024 * 0.5; // 0.5MB
export const MAX_VIDEO_SIZE = 1024 * 1024 * 20; // 20MB
export const MAX_ZIP_SIZE = 1024 * 1024 * 1000; // 1GB
export const CACHE_TIME = 60 * 5; //

